import { Vectors as r } from "../utils/index36.js";
const p = (o, t = r.Up) => r.Right.clone().applyAxisAngle(t, o);
export {
  p as rad2dir
};
//# sourceMappingURL=index8.js.map
